// https://app.asana.com/0/1201678459219544/1202141624509091/f
// eslint-disable-next-line import/no-extraneous-dependencies
import { Article, ArticleSearchDTO, ArticleSortType } from '@wix/answers-api';

import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();
const locale = renderModel.getLocale();

export const getArticlesByCategoryId = async (
  id: string,
  pageSize: number,
  page: number,
  httpClient: HttpClientFactory,
): Promise<Article[]> => {
  try {
    const dto: ArticleSearchDTO = {
      pageSize,
      page,
      categoryIds: [id],
      locale,
      sortType: ArticleSortType.POSITION,
    };

    const response = await httpClient
      .getInstance()
      .post(`${clientTopology.articlesAnswersSearchURL}`, dto);
    return response.data.items;
  } catch (error) {
    logger.log({
      message: `fail to fetch Article by category Id: ${id}`,
      error,
    });
    console.error(error);
    throw error;
  }
};
